import "@/App.css";
import "@/i18n";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import PortfolioPage from "@/pages/PortfolioPage";
import ContactPage from "@/pages/ContactPage";
import ServicesPage from "@/pages/ServicesPage";
import LimitedEditionPage from "@/pages/LimitedEditionPage";
import ArtworkDetailPage from "@/pages/ArtworkDetailPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ComingSoonPage from "@/pages/ComingSoonPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePage from "@/pages/CookiePage";
import { useEffect } from "react";

// Flip this to false (or use ?fullsite=1 query param) to expose the full site
const COMING_SOON_MODE = false;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const isAdminRoute = (pathname) => pathname.startsWith("/admin");
const isPreviewUnlocked = () => {
  if (typeof window === "undefined") return false;
  if (window.location.search.includes("fullsite=1")) {
    try { localStorage.setItem("eterna_preview", "1"); } catch { /* ignore */ }
    return true;
  }
  try { return localStorage.getItem("eterna_preview") === "1"; } catch { return false; }
};

function Layout() {
  const { pathname } = useLocation();
  const isAdmin = isAdminRoute(pathname);
  const showComingSoon = COMING_SOON_MODE && !isAdmin && !isPreviewUnlocked();

  if (showComingSoon) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="*" element={<ComingSoonPage />} />
      </Routes>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FAF9F6" }}>
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/limited-edition" element={<LimitedEditionPage />} />
          <Route path="/limited-edition/:artworkId" element={<ArtworkDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie" element={<CookiePage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
